module.exports = __webpack_public_path__ + "img/leaf.70691d18.png";